import { IntegrationProviders } from 'app-constants'
import { IUserObject } from 'types'

export const isAccountConnected = (
  user: IUserObject | undefined,
  provider: IntegrationProviders | string | undefined
) => {
  if (!user || !provider) return false
  if (provider === IntegrationProviders.MORTA) return true

  for (const integration of user.integrations) {
    if (integration.provider === provider) {
      if (!integration.accessToken) return false
      // OAuth providers have refreshToken + expiresAt; API key providers don't
      if (integration.refreshToken !== undefined && integration.refreshToken !== null) {
        return !!(integration.refreshToken && integration.expiresAt)
      }
      // API key provider — accessToken alone is sufficient
      return true
    }
  }

  return false
}

// Revizto's sign-in leaves Morta and returns to the Integrations page, and the
// token exchange must use the regional host the user signed in on.
// sessionStorage (not localStorage) because it survives that same-tab round
// trip but is per tab: two tabs connecting with different regions can't
// overwrite each other's region, and nothing lingers once the tab closes.
const REVIZTO_REGION_STORAGE_KEY = 'morta_revizto_oauth_region'

export const rememberReviztoRegion = (region: string): void => {
  try {
    sessionStorage.setItem(REVIZTO_REGION_STORAGE_KEY, region)
  } catch {
    // Storage blocked: the token exchange then fails with "A region is required".
  }
}

export const readReviztoRegion = (): string | undefined => {
  try {
    return sessionStorage.getItem(REVIZTO_REGION_STORAGE_KEY) ?? undefined
  } catch {
    return undefined
  }
}
